import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { action, flow, makeObservable, observable } from "mobx";
import { PluginUpdate } from "../models/pluginUpdate.js";
import { request } from "../utils/request.js";
import { locationRestPluginUpdateGet } from "../wp-api/pluginUpdate.get.js";
class PluginUpdateStore {
    busy = false;
    modalPlugin;
    pluginUpdates = new Map();
    pluginUpdateFetchErrors = new Map();
    rootStore;
    constructor(rootStore){
        this.rootStore = rootStore;
        makeObservable(this);
    }
    hideModal() {
        this.modalPlugin = undefined;
    }
    showInModal = flow(function*(slug) {
        this.modalPlugin = slug;
        try {
            yield this.fetchPluginUpdate(slug);
        } catch (e) {
            console.log(e);
            throw e;
        }
    });
    fetchPluginUpdate = flow(function*(slug) {
        this.busy = true;
        try {
            const result = yield request({
                location: locationRestPluginUpdateGet,
                params: {
                    slug
                }
            });
            const pluginUpdate = new PluginUpdate(result, this);
            this.pluginUpdates.set(slug, pluginUpdate);
            this.pluginUpdateFetchErrors.delete(slug);
            return pluginUpdate;
        } catch (e) {
            console.log(e);
            this.pluginUpdateFetchErrors.set(slug, e);
            throw e;
        } finally{
            this.busy = false;
        }
    });
}
_ts_decorate([
    observable
], PluginUpdateStore.prototype, "busy", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", String)
], PluginUpdateStore.prototype, "modalPlugin", void 0);
_ts_decorate([
    observable
], PluginUpdateStore.prototype, "pluginUpdates", void 0);
_ts_decorate([
    observable
], PluginUpdateStore.prototype, "pluginUpdateFetchErrors", void 0);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], PluginUpdateStore.prototype, "hideModal", null);
export { PluginUpdateStore };
